// src/services/timeline.js

const API_BASE = 'https://new.sbdemolition.online/api/timeline';

async function apiRequest(endpoint, options = {}) {
  const token = localStorage.getItem('authToken');
  
  const response = await fetch(`${API_BASE}${endpoint}`, {
    ...options,
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      ...(token && { 'Authorization': `Bearer ${token}` }),
      ...options.headers
    }
  });

  if (response.status === 401) {
    localStorage.removeItem('authToken');
    localStorage.removeItem('user');
    window.location.href = '/login';
    return;
  }

  if (!response.ok) {
    const error = await response.json().catch(() => ({ error: 'Network error' }));
    throw new Error(error.error || error.message || `API Error ${response.status}`);
  }

  return response.json();
}

export const timelineAPI = {
  // Get timeline for a project
  list: (projectId) => {
    return apiRequest(`/list.php?projectId=${projectId}`);
  }
};
